import Link from '@tiptap/extension-link'

export const CustomLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      href: {
        default: null,
        validate: (href: string) => {
          try {
            const url = new URL(href)
            return ['http:', 'https:', 'mailto:', 'tel:'].includes(url.protocol)
          } catch {
            return false
          }
        },
      },
      target: {
        default: '_blank',
      },
      rel: {
        default: 'noopener noreferrer',
      },
      class: {
        default: 'text-primary underline hover:no-underline transition-all',
      },
    }
  },

  addKeyboardShortcuts() {
    return {
      'Mod-k': () => {
        const previousUrl = this.editor.getAttributes('link').href
        const url = window.prompt('URL', previousUrl)

        if (url === null) {
          return false
        }

        if (url === '') {
          this.editor
            .chain()
            .focus()
            .extendMarkRange('link')
            .unsetLink()
            .run()

          return true
        }

        this.editor
          .chain()
          .focus()
          .extendMarkRange('link')
          .setLink({ href: url })
          .run()

        return true
      },
    }
  },
})